/**
 * BusinessSoon — secciones del dashboard empresarial en construccion, con el
 * lenguaje visual de la app (heroe navy estilo "El mapa de tu dinero" + chips).
 * Honestas: dicen QUE van a hacer y en que fase llegan, sin humo.
 * Visual: .soon-ola + tokens --fx-* (glass Ola A lite). Solo chrome.
 */
const SECTIONS = {
  tesoreria: {
    title: 'Tesoreria',
    tagline: 'Tu dinero trabaja hasta el dia del pago',
    desc: 'La caja de tu empresa deja de estar quieta: rinde en instrumentos de corto plazo de EE.UU. y se liquida sola dos dias antes de cada compromiso.',
    features: ['Escalera de liquidez (caja / 0-3 meses / excedente)', 'Calendario de compromisos: nomina, DIAN, proveedores', 'Liquidacion automatica antes de cada pago', 'Alertas de tasa de cambio para traer de tu matriz'],
    eta: 'Llega con la activacion de inversiones (Fase 2)',
  },
  equipo: {
    title: 'Equipo',
    tagline: 'Delegar sin perder el control',
    desc: 'Tu equipo prepara; solo tu apruebas. Cada rol con sus limites y todo auditado.',
    features: ['Roles: dueno aprueba, operadores preparan', 'Limites por persona y por lote', 'Lista blanca de beneficiarios', 'Auditoria de cada accion'],
    eta: 'La base ya funciona en Pagos; la gestion visual llega en el piloto',
  },
  extractos: {
    title: 'Extractos',
    tagline: 'Tu contador te lo va a agradecer',
    desc: 'Extracto mensual empresarial con todo discriminado y listo para conciliar.',
    features: ['Entradas, dispersiones y comisiones', 'Factura electronica DIAN automatica', 'Exportable para tu contador', 'PDF institucional'],
    eta: 'Llega con el piloto',
  },
  integraciones: {
    title: 'Integraciones y API',
    tagline: 'FlowexPay conectado a tu software',
    desc: 'Tu contabilidad se registra sola y tu software de nomina envia los pagos directo.',
    features: ['Siigo: contabilidad automatica', 'API con llaves por rol (tu contador solo lee)', 'Nadie aprueba por API — eso siempre eres tu', 'Estandares bancarios para SAP/Oracle'],
    eta: 'Fase 4 — despues del piloto',
  },
};

export default function BusinessSoon({ section }) {
  const s = SECTIONS[section] || { title: 'Proximamente', tagline: '', desc: '', features: [], eta: '' };
  return (
    <div className="soon-ola">
      <div className="soon-ola__hero">
        <div className="soon-ola__eyebrow">{s.title}</div>
        <h1 className="soon-ola__title">{s.tagline}</h1>
        <p className="soon-ola__desc">{s.desc}</p>
      </div>

      <div className="soon-ola__grid">
        {s.features.map((f, i) => (
          <div key={i} className="soon-ola__chip">
            <span className="soon-ola__dot" aria-hidden="true" />
            <span>{f}</span>
          </div>
        ))}
      </div>

      <div className="soon-ola__eta">{s.eta}</div>
    </div>
  );
}
